// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.bunny.net/css2?family=Inter:wght@400..700&display=swap);"]);
// Module
exports.push([module.id, ".main-page-title.page-title{display:none}.page-width--narrow{max-width:100vw;margin:0;padding:0 !important}.ant-image-preview-wrap{background-color:rgba(0,0,0,.4509803922)}", ""]);
// Exports
module.exports = exports;
